import { BASE_PATH } from "..";
import type { ContactInformationPost } from "../../types/contact-information";
import type { CardSettingsPost, CreditProductConfig } from "../../types/product";
import type { SveaRequest } from "../../types/request";
import type { SignatorEmailAssignPost } from "../../types/signing";

export const fetchEngagementsQuery: SveaRequest = () => ({
	url: `${BASE_PATH}/application/engagements`,
	method: "GET",
});

export const fetchApplicationsQuery: SveaRequest = () => ({
	url: `${BASE_PATH}/application-v1`,
	method: "GET",
});

export const fetchPromotionsQuery: SveaRequest = () => ({
	url: `/baas/promotion`,
	method: "GET",
});

export const fetchApplicationStatusQuery: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/application-status`,
	method: "GET",
});

export const initApplicationMutation: SveaRequest = (
	orgNr: string,
	applicationId: string,
	promotionCodes?: string[],
) => ({
	url: `${BASE_PATH}/application/initiate`,
	method: "POST",
	body: {
		orgNr,
		applicationId,
		promotionCodes,
	},
});

export const deleteApplicationMutation: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}`,
	method: "DELETE",
});

export const fetchApplicationRevision: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}`,
	method: "HEAD",
});

export const fetchSteps: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/steps-v1`,
	method: "GET",
});

export const creditScore: SveaRequest = (applicationId: string, orgNr: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/credit-score`,
	method: "POST",
	body: {
		orgNr,
	},
});

export const fetchApplicationDetails: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}`,
	method: "GET",
});

export const finalizeApplication: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/finalize`,
	method: "POST",
});

export const configureCreditProducts: SveaRequest = (
	applicationId: string,
	configurations: CreditProductConfig[],
) => ({
	url: `${BASE_PATH}/application/${applicationId}/product/configure-credit`,
	method: "POST",
	body: {
		configurations,
	},
});
export const configureCheckCredit: SveaRequest = (
	applicationId: string,
	config: { accountId: string; productId: string },
) => ({
	url: `${BASE_PATH}/application/${applicationId}/product/configure-check-credit`,
	method: "POST",
	body: {
		...config,
	},
});

export const registerOrganizationContactInfo: SveaRequest = (
	applicationId: string,
	contactInfo: ContactInformationPost,
) => ({
	url: `${BASE_PATH}/application/${applicationId}/organization-contact-information`,
	method: "POST",
	body: { ...contactInfo },
});

export const registerApplicantContactInfo: SveaRequest = (
	applicationId: string,
	contactInfo: ContactInformationPost,
) => ({
	url: `${BASE_PATH}/application/${applicationId}/applicant-contact-information`,
	method: "POST",
	body: { ...contactInfo },
});

export const fetchPersonInfo: SveaRequest = (swedishNationalId: string) => ({
	url: `org/application/person-info/${swedishNationalId}`,
	method: "GET",
});

export const fetchFullAccessUsers: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/full-access-users-v1`,
	method: "GET",
});

export const assignSignatorEmails: SveaRequest = (
	applicationId: string,
	signatories: SignatorEmailAssignPost[],
) => ({
	url: `${BASE_PATH}/application/${applicationId}/assign-signatories-contact-information`,
	method: "POST",
	body: {
		signatories,
	},
});
export const assignFullAccessUsers: SveaRequest = (
	applicationId: string,
	fullAccessUsers: { nationalIds: string[] },
) => ({
	url: `${BASE_PATH}/application/${applicationId}/full-access-users`,
	method: "POST",

	body: { ...fullAccessUsers },
});

export const removeFullAccessUsers: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/full-access-users`,
	method: "DELETE",
});

export const fetchCardDisplayNames: SveaRequest = (ssn: string) => ({
	url: `org/application/card-display-names-v1/${ssn}`,
	method: "GET",
});

export const fetchCountries: SveaRequest = () => ({
	url: "/org/application/countries-v1",
	method: "GET",
});

export const configureMastercard: SveaRequest = (
	applicationId: string,
	cardSettings: CardSettingsPost,
) => ({
	url: `${BASE_PATH}/application/${applicationId}/product/configure-mastercard`,
	method: "POST",

	body: { ...cardSettings },
});
